import { defineMessages } from 'react-intl';

export default defineMessages({
    policyLimit: {
        id: 'wmic-pe-capability-quoteandbind-common-react.covterm-util.policy-limit',
        defaultMessage: 'Policy Limit'
    }
});
